import React from "react";

function UnAuthorizedUserError() {
  return (
    <div className="flex items-center justify-center h-screen">
      <h1 className="text-3xl">Page Not found</h1>
    </div>
  );
}

export default UnAuthorizedUserError;
